module.exports = __webpack_public_path__ + "img/img9.34b30723.png";